import { Fragment } from "react";
import { Empty } from "./Empty";
import ColumnActions from "../molecules/ColumnActions";
import { PlusIcon } from "@heroicons/react/20/solid";
import { t } from "i18next";
import { TableLoader } from "../molecules/TableLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

type tagsProps = {
  id: number | string;
  name: string;
  description: string;
  color: string;
};

export type TableListTagsMarketingProps = {
  tagsMarketing: tagsProps[];
  OnclickTop: () => void;
  isLoading: boolean;

  onDelete?: (tagMarketing: any) => void;
  onEdit: (tagMarketing: any) => void;
};

const TableListTagsMarketing: React.FC<TableListTagsMarketingProps> = ({
  tagsMarketing,
  OnclickTop,
  isLoading,
  onDelete,
  onEdit,
}) => {
  return (
    <Fragment>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex w-64"></div>
        <div className="mt-8 sm:ml-auto sm:mt-4 sm:justify-between">
          <button
            onClick={OnclickTop}
            type="button"
            className="block rounded-full border-2 border-dashed border-gray-400 p-1 text-gray-400 shadow-sm hover:text-gray-500 focus-visible:outline-none"
          >
            <PlusIcon aria-hidden="true" className="h-5 w-5" />
          </button>
        </div>
      </div>
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full px-3 py-2 align-middle sm:px-6 lg:px-8">
            {!(tagsMarketing.length > 0) && isLoading ? (
              <Fragment>
                <TableLoader columns={2} rows={4} />
              </Fragment>
            ) : tagsMarketing.length === 0 ? (
              <Empty texto={t("brand.views.no_tags")} />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        {t("brand.views.description")}
                      </th>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        Descuento (%)
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {tagsMarketing.map((tagMarketing) => (
                      <tr key={tagMarketing.id}>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <span
                            style={{ backgroundColor: tagMarketing.color }}
                            className="inline-flex items-center rounded-md px-2 py-1 text-sm font-medium text-gray-900"
                          >
                            {tagMarketing.name}
                          </span>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          {tagMarketing.discount}
                        </td>
                        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                          <button
                            type="button"
                            onClick={() => onEdit(tagMarketing)}
                            className="text-primary-600 hover:text-primary-900 mr-4"
                          >
                            {t("general.edit")}
                            <span className="sr-only">
                              , {tagMarketing.name}
                            </span>
                          </button>
                          {onDelete && (
                            <button
                              type="button"
                              onClick={() => onDelete(tagMarketing)}
                              className="text-red-600 hover:text-red-900"
                            >
                              <FontAwesomeIcon icon={faTrashCan} />
                              <span className="sr-only">
                                {tagMarketing.name}
                              </span>
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TableListTagsMarketing;
